export const ALERT_TYPE = 'ALERT'
export const OFFER_TYPE = 'OFFER'
export const STANDARD_TYPE = 'STANDARD'
export const EVENT_TYPE = 'EVENT'

export const ACTION_TYPE_BOOK = 'BOOK'
export const ACTION_TYPE_ORDER = 'ORDER'
export const ACTION_TYPE_SHOP = 'SHOP'
export const ACTION_TYPE_LEARN_MORE = 'LEARN_MORE'
export const ACTION_TYPE_SIGN_UP = 'SIGN_UP'
export const ACTION_TYPE_CALL = 'CALL'